import { useMemo, useRef } from 'react'
import { useApiListResultAssessmentCourse } from '../../../../api-new/state/assessment'
import { BreadcrumbView } from '../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../shared/card/card-full-height-scroll-y'
import { useParamsInt } from '../../../../shared/hooks/location'
import { Menu, MenuDelete, MenuExport, MenuItem } from '../../../../shared/menu/menu'
import { IconUser, IconView } from '../../../../shared/icon/icon'
import { useRouteMatch } from '../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { useApiFormUserLogin } from '../../../../api-new/state/content'
import { TableAgClient } from '../../../../shared/table-builder/table-ag-client'
import { ColumnDateTime, ColumnMenu, ColumnText } from '../../../../shared/table-builder/table-columns'

export const AssessmentCourseAttempts = () => {
	const { url } = useRouteMatch()
	const { userID, assessmentID } = useParamsInt()

	const apiFormUserLogin = useApiFormUserLogin()
	const apiListTestResultAssessmentCourse = useApiListResultAssessmentCourse()

	const handleReady = () => apiListTestResultAssessmentCourse.get(`attempts/${assessmentID}/assessment/${userID}/user`)

	// The person's email names the crumb on every page under it (an attempt's
	// details or delete opened directly or reloaded), so it loads on the path,
	// not with the table, which those pages don't draw (audit F24).
	const handlePath = () => apiFormUserLogin.get(userID)

	const handleDestroyed = () => apiListTestResultAssessmentCourse.init()

	const title = useMemo(() => `Attempts ${apiFormUserLogin.form.email}`, [apiFormUserLogin.form])

	const tableRef = useRef()
	const handleExportCsv = () => tableRef.current.exportCsv('assessments')

	const HeaderMenu = () => (
		<Menu>
			<MenuExport onClick={handleExportCsv} show />
		</Menu>
	)

	return (
		<BreadcrumbView Icon={IconUser} text={apiFormUserLogin.form.email || ''} onPath={handlePath}>
			<CardFullHeightScrollY title={title} HeaderMenu={HeaderMenu}>
				<TableAgClient ref={tableRef} apiList={apiListTestResultAssessmentCourse} onReady={handleReady} onDestoryed={handleDestroyed}>
					<ColumnText field='course' sortable filter />
					<ColumnText field='title' sortable filter />
					<ColumnText field='type' sortable filter />
					<ColumnText field='passingScore' sortable filter />
					<ColumnText field='score' sortable filter />
					<ColumnText field='passed' sortable filter />
					<ColumnDateTime field='start' sortable filter />
					<ColumnDateTime field='end' sortable filter />
					<ColumnText field='duration' sortable filter />
					<ColumnMenu
						menu={(row) => (
							<Menu small>
								<MenuItem text='details' Icon={IconView} to={`${url}/${row.userAssessmentID}/details`} show pin />
								<MenuDelete Icon={IconView} to={`${url}/delete/${row.userAssessmentID}`} show />
							</Menu>
						)}
					/>
				</TableAgClient>
			</CardFullHeightScrollY>
		</BreadcrumbView>
	)
}
